module.exports = __webpack_public_path__ + "media/img/sg-99531698f90954f8c0dcb80daecdc2d8.png";